import { render, staticRenderFns } from "./DetailedTableSfrDrenaje.vue?vue&type=template&id=f589fec8&scoped=true"
import script from "./DetailedTableSfrDrenaje.vue?vue&type=script&lang=js"
export * from "./DetailedTableSfrDrenaje.vue?vue&type=script&lang=js"
import style0 from "./DetailedTableSfrDrenaje.vue?vue&type=style&index=0&id=f589fec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f589fec8",
  null
  
)

export default component.exports